<div class="quote-compare-container">
  <div class="top-header-bar">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h1 class="product-title">{{ product?.name || 'Product' }}</h1>
    </div>
    <button class="btn-print" (click)="printPage()">
      <img src="assets/public/print.png" alt="Print" class="print-icon">
      <span>Print</span>
    </button>
  </div>

  <div class="details-section" *ngIf="product">
    <div class="details-left">
      <!-- <h3 class="section-title">Product Details</h3> -->
      <div class="detail-item">
        <span class="detail-label">Product ID:</span>
        <span class="detail-value">{{ product.productId || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Product Category:</span>
        <span class="detail-value">{{ product.category?.name || '-' }} ({{ product.category?.categoryId || '-' }})</span>
      </div>
    </div>
    <div class="details-divider"></div>
    <div class="details-right">
      <!-- <h3 class="section-title">Quote and Shipping Details</h3> -->
      <div class="detail-item">
        <div class="detail-label-wrapper">
          <span class="detail-label">Quote Submission Due Date</span>
          <span class="detail-sub-label">(DD/MM/YYYY)</span>
        </div>
        <span class="detail-value">: {{ formatDate(product.quoteSubmissionDueDate) }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Shipping Term:</span>
        <span class="detail-value">{{ product.shippingDetails?.shippingTerm || '-' }}</span>
      </div>
      <div class="detail-item" *ngIf="product.shippingDetails?.shippingTerm === 'DELIVERED'">
        <span class="detail-label">Shipping Address:</span>
        <span class="detail-value">
          {{ product.shippingDetails?.addressLine1 || '' }} {{ product.shippingDetails?.addressLine2 || '' }}, 
          {{ product.shippingDetails?.city || '' }}, {{ product.shippingDetails?.state || '' }}, 
          {{ product.shippingDetails?.country || '' }} - {{ product.shippingDetails?.pincode || '' }}
        </span>
      </div>
    </div>
  </div>

  <div class="search-filter-section">
    <div class="search-input-wrapper">
      <input
        type="text"
        class="search-input"
        placeholder="Search by Quote ID or Supplier Name or Supplier ID"
        [value]="searchQuery"
        (input)="onSearchInput($event)"
        (keyup)="onSearchInput($event)">
      <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="6" stroke="#6b7280" stroke-width="1.5"/>
        <path d="M14 14L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="validity-date-dropdown">
      <div class="validity-date-header" (click)="toggleValidityDateDropdown()">
        <span>Filter by Validity Date</span>
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="showValidityDateDropdown">
          <path d="M1 1L6 6L11 1" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="validity-date-options" *ngIf="showValidityDateDropdown">
        <div class="validity-option" [class.active]="validityDateFilter === 'all'" (click)="selectValidityDateFilter('all')">
          All
        </div>
        <div class="validity-option" [class.active]="validityDateFilter === 'ascending'" (click)="selectValidityDateFilter('ascending')">
          Ascending
        </div>
        <div class="validity-option" [class.active]="validityDateFilter === 'descending'" (click)="selectValidityDateFilter('descending')">
          Descending
        </div>
      </div>
    </div>
    <div class="pricing-view-dropdown">
      <div class="pricing-view-header" (click)="togglePricingDropdown()">
        <span>View Pricing as</span>
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="showPricingDropdown">
          <path d="M1 1L6 6L11 1" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="pricing-view-options" *ngIf="showPricingDropdown">
        <div class="pricing-option" [class.active]="pricingView === 'unit'" (click)="selectPricingView('unit')">
          Per Unit Price
        </div>
        <div class="pricing-option" [class.active]="pricingView === 'total'" (click)="selectPricingView('total')">
          Total Price
        </div>
      </div>
    </div>
    <button class="btn-reset">Reset</button>
  </div>

  <div class="comparison-table-container" *ngIf="comparisonQuantities.length > 0 && comparisonSuppliers.length > 0">
    <table class="comparison-table">
      <thead>
        <tr>
          <th class="total-quotes-col">Total Quotes <span class="quote-label">* in DD/MM/YYYY</span></th>
          <th *ngFor="let supplier of comparisonSuppliers" class="supplier-col">
            <div class="supplier-header-cell">
              <div class="supplier-name-row">
                <span class="supplier-name">{{ supplier.supplierName }}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="external-link-icon">
                  <path d="M10 2H4C3.44772 2 3 2.44772 3 3V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V6M10 2L13 5M10 2V5H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="supplier-id-location">
                <span class="supplier-id-code" *ngIf="supplier.supplierIdCode">{{ supplier.supplierIdCode }}</span>
                <span class="supplier-location" *ngIf="supplier.supplierLocation">{{ supplier.supplierLocation }}</span>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Quote ID Row -->
        <tr class="data-row">
          <td class="total-quotes-cell">
            <div class="quote-id-label">Quote ID:</div>
          </td>
          <td *ngFor="let supplier of comparisonSuppliers" class="supplier-data-cell">
            <div class="quote-id-value-row">
              <span class="quote-id-text">{{ supplier.quoteId }}</span>
              <span class="status-badge" [ngClass]="getStatusClass(supplier.status)">
                {{ getStatusText(supplier.status) }}
              </span>
            </div>
          </td>
        </tr>
        <!-- Submission Date Row -->
        <tr class="data-row">
          <td class="total-quotes-cell">
            <div class="date-label">Submission Date :</div>
          </td>
          <td *ngFor="let supplier of comparisonSuppliers" class="supplier-data-cell">
            <div class="date-value">{{ formatDate(supplier.submissionDate) }}</div>
          </td>
        </tr>
        <!-- Validity Date Row -->
        <tr class="data-row">
          <td class="total-quotes-cell">
            <div class="date-label">Validity Date :</div>
          </td>
          <td *ngFor="let supplier of comparisonSuppliers" class="supplier-data-cell">
            <div class="date-value">{{ formatDate(supplier.validityDate) }}</div>
          </td>
        </tr>
        <!-- Quantity/Price Header Row -->
        <tr class="header-row">
          <td class="total-quotes-cell">
            <div class="quantity-header">Quantity</div>
          </td>
          <td *ngFor="let supplier of comparisonSuppliers" class="supplier-data-cell">
            <div class="price-header">Price</div>
          </td>
        </tr>
        <!-- Quantity and Price Rows -->
        <tr *ngFor="let qty of comparisonQuantities" class="price-row">
          <td class="quantity-cell">
            {{ formatQuantity(qty.quantity, qty.uom) }}
          </td>
          <td *ngFor="let supplier of comparisonSuppliers" class="price-cell">
            <ng-container *ngIf="getPriceForQuantity(supplier, qty.quantity, qty.uom) as price">
              <div class="price-value" *ngIf="pricingView === 'unit'">
                {{ supplier.currency || 'INR' }} {{ formatNumber(price.unitPrice) }}
              </div>
              <div class="price-value" *ngIf="pricingView === 'total'">
                {{ supplier.currency || 'INR' }} {{ formatNumber(price.totalPrice) }}
              </div>
            </ng-container>
            <ng-container *ngIf="!getPriceForQuantity(supplier, qty.quantity, qty.uom)">
              <div class="price-na">-</div>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="empty-state" *ngIf="comparisonQuantities.length === 0 || comparisonSuppliers.length === 0">
    <p>No comparison data available. Please select quotes with pricing information.</p>
  </div>
</div>
